<template>
  <div ref="main" class="pro-wrapper flex-col-start-row-center" style="position: relative;" v-loading="pageLoading" :element-loading-text="$t('message.loading')"
  element-loading-spinner="el-icon-loading" element-loading-background="#00193d" v-bind:style="{transform: `scale(${fullscreenBtn ? 0.8 : 1}) translate(-12.5%, -12.5%)`}">
    <el-button class="fullscreen-btn" type="primary" circle @click="fullscreen" v-if="fullscreenBtn">
      <i class="el-icon el-icon-full-screen" style="font-size: 30px;"></i>
    </el-button>
    <div class="pro-header">

      <div class="title">{{$t('message.fever_monitoring_dashboard')}}</div>

      <div class="time">{{nowTime}}</div>

    </div>
    <div class="pro-body">
      <div class="home-wrapper">
        <div class="content_top ">
          <div class="item_title top">{{$t('message.real_time_person_statistics')}}</div>
          <div class="real-person-header flex-row-start-col-center">
            <div class="flex-row-start-col-center">
              <div>{{$t('message.name')}}</div>
              <div>{{$t('message.temperature_body')}}</div>
              <div>{{$t('message.thermometry_time')}}</div>
            </div>
            <div class="flex-row-start-col-center">
              <div>{{$t('message.name')}}</div>
              <div>{{$t('message.temperature')}}</div>
              <div>{{$t('message.thermometry_time')}}</div>
            </div>
            <!--        <div>姓名</div>-->
            <!--        <div>身份证号</div>-->
            <!--        <div>体温</div>-->
            <!--        <div>测温时间</div>-->
          </div>
          <div class="real-person-table">
            <div class="real-person-row flex-row-start-col-center"
                 :class="{'danger':Number((realPerson[index-1]?realPerson[index-1].temperature:0))>=37.3}"
                 v-for="(index) in 20" :key="index-1"
            >
              <!--          v-for="(item,index) in realPerson" :key="index"-->
              <!--          :style="index|rowStyleFilter(realPerson.length)"-->
              <div class="real-person-cell" v-if="realPerson[index-1]">
                <span v-if="realPerson[index-1].is_visitor">{{$t('message.visitor')}}</span>
                <span v-else>{{realPerson[index-1].name}}</span>
              </div>
              <div class="real-person-cell" v-if="realPerson[index-1]">
                {{realPerson[index-1].temperature}}℃<span
                v-if="Number(realPerson[index-1].temperature)>=37.3">（{{$t('message.abnormal_tem')}}）</span>
              </div>
              <div class="real-person-cell" v-if="realPerson[index-1]">
                {{$options.filters.timeFilter(realPerson[index-1].create_time)}}
              </div>
            </div>
          </div>
        </div>
        <div class="content_bottom flex-center">
          <div class="item">
            <div class="item_title">{{$t('message.number_of_person_each_period')}}</div>
            <div class="line-chart_canvas" ref="lineChart"></div>
          </div>
          <div class="item" style="margin: 0 2vh">
            <div class="item_title">{{$t('message.today_person_tem_statistics')}}</div>
            <div class="user-temp flex-center">
              <div class="percentage flex-center" ref="percentage">
                {{todayTotal.normalRate}}
                <el-progress type="circle" v-if="this.percentageWidth" :percentage="todayTotal.normalRate"
                             :width="this.percentageWidth" :stroke-width="15" color="#29d9d2"></el-progress>
              </div>
              <div class="part flex-col-start-row-center">
                <div class="part-item flex-row-start-col-center" v-for="(item,index) in partArray" :key="index">
                  <div class="part-item_label">
                    {{item.name}}℃
                  </div>
                  <div class="part-item_value">
                    <el-progress :percentage="item.value" :stroke-width="12" color="#00adee"
                                 :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          <div class="item">
            <div class="item_title">{{$t('message.history_person_entry_statistics')}}</div>
            <div class="bar-chart_canvas" ref="barChart"></div>
          </div>
        </div>
        <div class="person-images_wrapper flex-row-center-col-start">
          <!--      <transition name="custom-classes-transition" enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutLeft">-->
          <div class="person-images_item" :class="{'danger':Number(item.temperature)>=37.3}"
               v-for="(item,index) in personImages"
               :key="item.id" :style="index|imageStyleFilter(item.isDelete,personImages)">
            <img :src="item.image" alt="">
            <div class="info flex-center">
              <span v-if="item.is_visitor">{{$t('message.visitor')}}</span>
              <span v-else>{{item.name}}</span>
              <span>{{item.temperature}}℃</span>
              <span v-if="Number(item.temperature)>=37.3">（{{$t('message.abnormal_tem')}}）</span>
            </div>
          </div>
          <!--      </transition>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client'

let socket = null

export default {
  name: 'Home',
  components: {},
  data () {
    return {
      fullscreenBtn: true,
      lang: 'cn',
      pageLoading: true,
      dateNow: Date.now(),
      realPerson: [],
      todayTotal: {
        abnormal: 1,
        normal: 1,
        normalRate: 0
      },
      partArray: [],
      lineDom: '',
      barDom: '',
      periodTimeChartOption: {
        grid: {
          left: '3%',
          right: '4%',
          top: '25%',
          bottom: '4%',
          containLabel: !0
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: !1
          },
          axisLine: {
            show: !1
          },
          splitLine: {
            show: !1
          },
          axisLabel: {
            show: !0,
            textStyle: {
              color: 'rgba(255, 255, 255, .6)',
              fontSize: '11'
            }
          }
        },
        yAxis: [{
          min: 0,
          nameTextStyle: {
            color: 'rgba(255, 255, 255, .6)'
          },
          boundaryGap: ['35%', '35%'],
          show: !0,
          axisTick: {
            show: !1
          },
          axisLine: {
            show: !1
          },
          axisLabel: {
            show: !0,
            textStyle: {
              color: 'rgba(255, 255, 255, .6)',
              fontSize: '11'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, .6)'
            }
          }
        }],
        series: [
          {
            name: this.$t('message.normal_person_times'),
            color: '#04CDF4',
            data: [],
            type: 'line',
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#04CDF4'
              }, {
                offset: 1,
                color: 'rgba(120, 120, 120, 0)'
              }])
            }
          },
          {
            name: this.$t('message.abnormal_person_times'),
            color: '#F0FF00',
            data: [],
            type: 'line',
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#F0FF00'
              }, {
                offset: 1,
                color: 'rgba(120, 120, 120, 0)'
              }])
            }
          }]
      },
      historyChartOption: {
        grid: {
          left: '3%',
          right: '4%',
          top: '25%',
          bottom: '4%',
          containLabel: !0
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: !1
          },
          axisLine: {
            show: !1
          },
          splitLine: {
            show: !1
          },
          axisLabel: {
            show: !0,
            textStyle: {
              color: 'rgba(255, 255, 255, .6)',
              fontSize: '11'
            }
          }
        },
        yAxis: [{
          min: 0,
          nameTextStyle: {
            color: 'rgba(255, 255, 255, .6)'
          },
          boundaryGap: ['35%', '35%'],
          show: !0,
          axisTick: {
            show: !1
          },
          axisLine: {
            show: !1
          },
          axisLabel: {
            show: !0,
            textStyle: {
              color: 'rgba(255, 255, 255, .6)',
              fontSize: '11'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, .6)'
            }
          }
        }],
        series: [{
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#01F0FF'
          }, {
            offset: 1,
            color: '#005559'
          }]),
          name: this.$t('message.normal_person_times'),
          type: 'bar',
          barWidth: '22px',
          data: []
        }, {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#FBA980'
          }, {
            offset: 1,
            color: '#F7CB6B'
          }]),
          name: this.$t('message.abnormal_person_times'),
          type: 'bar',
          barWidth: '22px',
          data: []
        }]
      },
      percentageWidth: '',
      personImages: [],
      imageHistory: {},
      organizationId: '120'
    }
  },
  mounted () {
    let lang = localStorage.getItem('lang');
    this.lang = lang
    this.startConnect()

    window.onresize = () => {
      return (() => {
        this.initSize()
      })()
    }
    this.init()

    document.onfullscreenchange = event => {
      this.fullscreenBtn = !this.fullscreenBtn
    }
  },
  destroyed () {
    window.onresize = ''

    socket.close()
    socket = null
  },
  methods: {
    fullscreen () {
      this.$refs['main'].requestFullscreen()
    },
    startConnect () {
      let token = JSON.parse(this.$localStorage.get('ManageUserInfo')).token
      const subOrgIDQuery = this.$store.state.currentWatchOrgId === this.$store.state.adminCurrentWatchSubOrgInfo.org_id ? '' : `&sub_org_id=${this.$store.state.adminCurrentWatchSubOrgInfo.org_id}`

      socket = io(this.BASE_URL, { transports: ['websocket'], timestampRequests: true, path: '/socketio/socket.io', query: `token=${token}${subOrgIDQuery}` })

      socket.on('connect', (error) => {
        console.log('on connect', error)
      })

      socket.on('disconnect', data => {      
        console.log('on disconnect')
      })

      socket.on('connect_error', error => {
        this.$message({
          message: error || this.$t('message.service_error'),
          type: 'error'
        })
      })

      socket.on('connect_timeout', (timeout) => {
        console.log('aaaaaaa', timeout)
      })
      socket.on('message', data => {
        console.log('====================================')
        console.log(data)
        console.log('====================================')
        this.loadPage(data)
      })
      socket.on('authorization_fail', () => {
        this.$message({
          message: this.$t('message.network_fail'),
          type: 'error'
        })
        this.$router.replace('/login')
      })
    },

    init () {
      this.timeLoad()
      this.initSize()
      // TODO: 发请求验证token
    },
    timeLoad () {
      this.dateNow = Date.now()
      setTimeout(() => {
        this.timeLoad()
      }, 1000)
    },
    loadPage (data) {
      console.log(data)
      if (this.$route.name !== 'BigScreen') {
        return
      }
      this.initLineChart(data.hourStatistics)
      this.initBarChart(data.dayStatistics)

      this.initTemp(data.temperatureStatistics)
      this.initRealPerson(data.last10)
      data.last1 = data.last10[data.last10.length - 1]

      
      if (!this.imageHistory.create_time) {
        if (data.last1) {
          this.imageHistory = data.last1
        }
      } else {
        if (data.last1 && (this.imageHistory.create_time !== data.last1.create_time)) {
          this.imageHistory = data.last1
          this.initImage(data.last1)
        }
      }
      this.pageLoading = false
    },
    initSize () {
      this.percentageWidth = this.$refs.percentage.offsetWidth
      if (this.lineDom) {
        this.lineDom.resize()
      }
      if (this.barDom) {
        this.barDom.resize()
      }
    },
    initTemp (todayArray) {
      let todayTotal = {}
      todayTotal.normal = todayArray['36.0'] + todayArray['36.5'] + todayArray['37.0']
      todayTotal.abnormal = todayArray['37.3']
      todayTotal.total = todayTotal.normal + todayTotal.abnormal
      todayTotal.normalRate = todayTotal.total === 0 ? 0 : parseInt((todayTotal.normal * 100) / todayTotal.total)
      
      this.todayTotal = todayTotal
      let partArray = []
      let total = todayTotal.abnormal + todayTotal.normal
      for (let key in todayArray) {
        console.log(key)
      
        let item = {
          name: key,
          value: todayArray[key] / total * 100 || 0
        }
        partArray.unshift(item)
      }
      this.partArray = partArray
    },
    initImage (data) {
      if (!data) {
        return
      }
      data.id = Math.random()
      data.isDelete = false
      if (this.personImages.length >= 3) {
        let deletes = this.personImages.slice(0, this.personImages.length - 2)
        deletes.forEach((item) => {
          this.deleteImage(item.id)
        })
      }
      this.personImages.push(data)
      this.autoDeleteImage(data.id)
    },
    autoDeleteImage (id) {
      setTimeout(() => {
        this.deleteImage(id)
      }, 5000)
    },
    deleteImage (id) {
      let willDeleteIndex = this.personImages.findIndex((item, index) => {
        return item.id === id
      })
      if (willDeleteIndex >= 0 && !this.personImages[willDeleteIndex].isDelete) {
        this.personImages[willDeleteIndex].isDelete = true
        setTimeout(() => {
          this.$nextTick(() => {
            let deleteIndex = this.personImages.findIndex((item, index) => {
              return item.id === id
            })
            if (deleteIndex >= 0 && this.personImages[deleteIndex].isDelete) {
              this.personImages.splice(deleteIndex, 1)
            }
          })
        }, 600)
      }
    },
    initRealPerson (data) {
      let realPerson
      realPerson = this.realPerson
      data.reverse()
      let length = data.length
      let start = realPerson.length - length > 0 ? realPerson.length - length : 0
      realPerson.splice(start, length, ...data)
      this.realPerson = realPerson
    },
    initLineChart (data) {
      if (!this.lineDom) {
        this.lineDom = this.$echarts.init(
          this.$refs.lineChart
        )
      }
      let xData = []
      let yDataZero = []
      let yDataOne = []
      data.forEach((item) => {
        xData.push(`${item.hour.split(' ')[1]}:00`)
        yDataZero.push(item.normal)
        yDataOne.push(item.abnormal)
      })
      this.periodTimeChartOption.xAxis.data = xData
      this.periodTimeChartOption.series[0].data = yDataZero
      this.periodTimeChartOption.series[1].data = yDataOne
      this.lineDom.setOption(this.periodTimeChartOption)
    },
    initBarChart (data) {
      if (!this.barDom) {
        this.barDom = this.$echarts.init(
          this.$refs.barChart
        )
      }
      let xData = []
      let yDataZero = []
      let yDataOne = []
      data.forEach((item) => {
        xData.unshift(item.day)
        yDataZero.unshift(item.normal)
        yDataOne.unshift(item.abnormal)
      })
      this.historyChartOption.xAxis.data = xData
      this.historyChartOption.series[0].data = yDataZero
      this.historyChartOption.series[1].data = yDataOne
      this.barDom.setOption(this.historyChartOption)
    },
    deepClone (obj) {
      let objClone = Array.isArray(obj) ? [] : {}
      if (obj && typeof obj === 'object') {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            // 判断ojb子元素是否为对象，如果是，递归复制
            if (obj[key] && typeof obj[key] === 'object') {
              objClone[key] = this.deepClone(obj[key])
            } else {
              // 如果不是，简单复制
              objClone[key] = obj[key]
            }
          }
        }
      }
      return objClone
    }
  },
  computed: {
    nowTime () {
      return this.$options.filters.timeFilter(this.dateNow / 1000)
    }
  },
  filters: {
    rowStyleFilter (index, length) {
      let maxSize = 10
      let important = length - index - 1
      let opacity = 1
      let top = '0%'
      if (length < 10) {
        top = `${index * 10}%`
        opacity = 1 - (length - index - 1) * 0.05
      } else {
        let newPostion = 10 - (length - index)
        top = `${newPostion * 10}%`
        opacity = 0.5 + (newPostion + 1) * 0.05
      }
      let style = {
        'opacity': opacity,
        'top': top
      }
      return style
    },
    imageStyleFilter (index, isDelete, array) {
      let length = 0
      let arrayLength = array.length
      array.forEach((aItem) => {
        if (!aItem.isDelete) {
          length++
        }
      })
      let opacity = 1
      let marginLeft = '3vh'
      if (isDelete) {
        opacity = '0 !important'
        marginLeft = '-107vh !important'
      } else if (length === 1) {
        opacity = 1
        marginLeft = '-19vh'
      } else if (length === 2) {
        opacity = 1
        marginLeft = `${(length - (index - (arrayLength - length)) - 1) * (-44) + 3}vh`
      } else if (length === 3) {
        opacity = 1
        marginLeft = `${(length - (index - (arrayLength - length)) - 1) * (-44) + 25}vh`
      }
      let style = {
        'opacity': opacity,
        'margin-left': marginLeft
      }
      return style
    },
    idCardFilter (idCard) {
      if (!idCard || idCard.length !== 18) {
        return '————'
      }
      let a = idCard
      let b = a.substring(6, 14)
      let c = a.replace(b, '********')
      return c
    }
  }
}
</script>

<style lang="scss">
  @-webkit-keyframes rowStart {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @-webkit-keyframes imageStart {
    from {
      opacity: 0;
      transform: translateX(50%);
      margin-right: -41vh;
    }
    to {
      opacity: 1;
      transform: translateX(0);
      margin-right: 3vh;
    }
  }

  @-webkit-keyframes imageEnd {
    from {
      opacity: 1;
      transform: translateX(0);
      /*margin-right: 1vh;*/
    }
    to {
      opacity: 0;
      transform: translateX(-50%);
      /*margin-right: 1vh;*/
    }
  }

  .el-progress__text {
    font-weight: 700;
    font-size: 3.2vh !important;
    color: #2bfaff;
  }

  .el-progress-bar__outer {
    background: rgba(255, 255, 255, 0.2);
  }

  .select-popper {
    background: rgba(#333, .6);
    border-color: rgba(#333, .6);

    .el-select-dropdown__item {
      color: rgba(255, 255, 255, .9);
      font-size: 1.8vh;
      height: 4vh;
      line-height: 4vh;

      &:hover, &.hover {
        background-color: rgba(255, 255, 255, .1);
      }

      &.selected {
        color: #3788FF;
      }
    }

    .popper__arrow {
      border-bottom-color: rgba(#333, .6) !important;

      &:after {
        border-bottom-color: rgba(#333, .6) !important;
      }
    }
  }

  .pro-wrapper {
    /*height: 100%;*/
    width: 100vw;
    height: 100vh;
    background: url('../assets/img/bigscreen/bg.png') no-repeat 50%/100% 100%;
    & > * {
      width: 100%;
    }

    & > .fullscreen-btn{
      position: absolute;
      top: 20px;
      right: -120px;
      width: 80px;
      height: 80px;
      z-index: 100;
    }
  }

  .pro-header {
    position: relative;
    padding: 0 2vh;
    line-height: 5vh;
    height: 12vh;
    font-size: 3vh;
    text-align: center;
    color: #7efafc;
    background: url(../assets/img/bigscreen/header.png) no-repeat 50%/100% 100%;

    .describe {
      position: absolute;
      left: 2vh;
      top: 0;
      font-size: 1.8vh;
    }

    .title {
      /*display: inline-block;*/
      font-size: 4.6vh;
      font-weight: 700;
      line-height: 11.6vh;
      text-align: center;
    }

    .logo {
      position: absolute;
      top: 0.9vh;
      left: 13.5%;
      width: 15.3vh;
      height: 6.3vh;

      img {
        height: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 10.5vh;
        height: 0.6vh;
        background: linear-gradient(90deg, #01d1ff, #286be9);
        border-radius: 0.3vh;
      }
    }

    .time {
      position: absolute;
      right: 2vh;
      top: 0;
      display: inline-block;
      font-size: 1.8vh;
    }
  }

  .pro-body {
    position: relative;
    height: 88vh;
    padding: 0 2vh 2vh;

  }

  .home-wrapper {
    position: relative;
    & > * {
      width: 100%;
    }

    .content_top {
      position: relative;
      background: url(../assets/img/bigscreen/item-wrap.png) no-repeat 50%/100% 100%;
      padding: 6vh 4vh 2vh 4vh;
      box-sizing: border-box;
      height: 56vh;

      .real-person-header {
        width: 100%;
        height: 4vh;
        line-height: 4vh;
        font-size: 2vh;
        color: #7efafc;

        & > * {
          flex: 1;
          margin: 0 3vh;
          background: #0e2c81;

          & > div {
            flex: 1;
            text-align: center;
          }
        }
      }

      .real-person-table {
        position: relative;
        flex: 1;
        width: 100%;
        color: #fff;
        overflow: hidden;
        transition: all linear 0.2s;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 44vh;

        .real-person-row {
          /*position: absolute;*/
          /*height: 10%;*/
          /*width: 100%;*/
          /*opacity: 0;*/
          /*top: 110%;*/
          /*transition: all 0.2s;*/
          /*animation: rowStart .2s;*/
          /*flex: 1;*/
          height: 10%;
          width: calc(50% - 6vh);
          margin: 0 3vh;
          transition: all 0.2s;
          animation: rowStart .2s;

          &.danger {
            color: #ff3b30;
          }

          &:nth-child(even) {
            background: #0e2c81;
          }
        }

        .real-person-cell {
          flex: 1;
          text-align: center;
          font-size: 1.8vh;
        }
      }
    }

    .content_bottom {
      margin-top: 2vh;
      height: 28vh;

      .item {
        position: relative;
        height: 100%;
        flex: 1;
        background: url(../assets/img/bigscreen/item-bg.png) no-repeat 50%/100% 100%;
      }

      .user-temp {
        height: 100%;
        width: 100%;
        padding: 4vh 1.5vh 0;

        & > * {
          height: 100%;
        }

        .percentage {
          /*flex: 1;*/
          width: 33%;

          svg path:first-child {
            stroke: rgba(255, 255, 255, .2);
          }
        }

        .part {
          /*flex: 2;*/
          width: 67%;
          padding: 3.5vh 0 1.5vh 1.5vh;

          .part-item {
            flex: 1;
            width: 100%;

            .part-item_label {
              font-size: 1.8vh;
              width: 6vh;
              color: #ffffff;
            }

            .part-item_value {
              flex: 1;
            }
          }
        }
      }

      .line-chart_canvas {
        height: 100%;
        width: 100%;
      }

      .bar-chart_canvas {
        height: 100%;
        width: 100%;
      }
    }

    .item_title {
      position: absolute;
      top: 2%;
      left: 50%;
      z-index: 1;
      white-space: nowrap;
      padding: 0 4.5vh;
      transform: translateX(-50%);
      background: url(../assets/img/bigscreen/item-header.png) no-repeat 50%/100% 100%;
      line-height: 4vh;
      font-size: 1.8vh;
      color: #fff;

      &.top {
        top: .3%;
      }
    }

    .person-images_wrapper {
      position: absolute;
      height: 100%;
      width: 100%;
      padding-top: 10vh;
      z-index: 999;
      overflow: hidden;
      top: 0;
      left: 0;

      .person-images_item {
        position: absolute;
        left: 50%;
        height: 45vh;
        width: 38vh;
        padding: 2vh;
        margin-right: 3vh;
        margin-left: 3vh;
        background: url(../assets/img/bigscreen/item-user-wrap.png) no-repeat 50%/100% 100%;
        color: #ffffff;
        opacity: 1;
        transition: all 0.3s;
        animation: imageStart .3s;

        /*position: relative;
        height: 45vh;
        width: 38vh;
        padding: 2vh;
        margin-right: 3vh;
        margin-left: 3vh;
        background: url(../assets/img/bigscreen/item-user-wrap.png) no-repeat 50%/100% 100%;
        color: #ffffff;
        opacity: 1;
        transition: all 0.3s;
        animation: imageStart .3s;*/

        &.isDelete {
          opacity: 0 !important;
          margin-left: -41vh
        }

        &.danger {
          .info {
            color: #ff3b30;
            font-weight: 600;
          }
        }

        img {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }

        .info {
          position: absolute;
          bottom: 2vh;
          width: calc(100% - 4vh);
          height: 5vh;
          line-height: 5vh;
          font-size: 2vh;
          background: rgba(#05174c, .7);

          span {
            margin-right: 1vh;
          }
        }
      }
    }
  }
</style>
